import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import CloseIcon from '@mui/icons-material/Close';

import { loadCourseTemplate } from '../../../store/courseService';
import { selectUsersForNames } from '../../../store/userSelectors';
import { loadUsersMinimalDetails } from '../../../store/userService';
import HealthInfo from '../../healthInfo/HealthInfo';
import LoadingSpinner from '../../ui/LoadingSpinner';
import ScheduleModuleAttendanceView from '../modules/scheduleModuleAttendance/ScheduleModuleAttendanceView';

import app from '../../../app.module.css';
import cardClasses from '../../../commonStyles/cardContainer.module.css';
import dropdownClasses from '../courseStyles/rowDropDown.module.css';

const CourseInstanceDetails = ({
    row,
    onClose,
    isDisabled,
    isAttendanceAccessDisabled,
    isSelfEmployedCoach
}) => {
    const dispatch = useDispatch();

    // STORE STATE
    const currentTemplate = useSelector((state) => state.entities.courseService.currentTemplate);
    const users = useSelector(selectUsersForNames);

    // USE EFFECTS
    useEffect(() => {
        if (row) {
            dispatch(loadCourseTemplate(row.courseTemplateId));
            const userIds = [...new Set(row.modules.map((el) => el.userId))];
            const missingAdviserIds = userIds
                .filter((el) => !users.find((entry) => entry.id === el))
                .filter((el) => el);
            missingAdviserIds.length > 0 && dispatch(loadUsersMinimalDetails(missingAdviserIds));
        }
    }, [row]);

    return !currentTemplate || Object.keys(currentTemplate).length < 1 ? (
        <LoadingSpinner content="No course/module information found" />
    ) : (
        <div className={dropdownClasses.rowDropdown}>
            <div>
                <h3 className={app.sectionHeading}>
                    {row.name} ({row.code})
                </h3>
                <p className={app.paragraphContent} data-testid="course_description">
                    {row.description}
                </p>
                {currentTemplate.healthInformationCaptured && (
                    <HealthInfo
                        healthInformationCaptured={true}
                        healthInformationIds={currentTemplate.healthInformationIds}
                    />
                )}
                <div className={cardClasses.cardContainer}>
                    <h3 className={app.sectionHeading}>Module Selection</h3>
                    <div className={cardClasses.cards}>
                        {row.modules.map((el) => (
                            <div key={el.id}>
                                <ScheduleModuleAttendanceView
                                    course={row}
                                    module={el}
                                    isSchedulingDisabled={isDisabled}
                                    isAttendanceAccessDisabled={isAttendanceAccessDisabled}
                                    isSelfEmployedCoach={isSelfEmployedCoach}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div className={dropdownClasses.exit} onClick={onClose}>
                    Close details
                    <CloseIcon />
                </div>
            </div>
        </div>
    );
};

CourseInstanceDetails.propTypes = {
    row: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    isAttendanceAccessDisabled: PropTypes.bool,
    isSelfEmployedCoach: PropTypes.bool
};

export default CourseInstanceDetails;
